import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "About", href: "/#about", id: "nav-about-link" },
  { label: "Programs", href: "/#programs", id: "nav-programs-link" },
  { label: "Retreats", href: "/#retreats", id: "nav-retreats-link" },
  { label: "Mission", href: "/#mission", id: "nav-mission-link" },
  { label: "Blog", href: "/blog", id: "nav-blog-link" },
  { label: "Contact", href: "/#contact", id: "nav-contact-link" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/70 backdrop-blur-xl backdrop-saturate-150 border-b border-white/40"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-3 group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_rb-coaching-hub-1/artifacts/dkty72fa_logo.png"
            alt="RB InnerRise Coaching Academy"
            data-testid="nav-logo-img"
            className="h-12 w-12 object-cover rounded-lg"
          />
          <div className="leading-tight">
            <div className="font-serif text-[#0B2B40] text-lg md:text-xl tracking-tight">
              RB InnerRise Coaching Academy
            </div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-[#4A5568]">
              RBICA · Coaching
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={l.id}
              className="text-sm font-medium text-[#1A202C] hover:text-[#1D4E89] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="/#discovery-call"
          data-testid="nav-discovery-cta"
          className="hidden md:inline-block bg-[#0B2B40] text-white hover:bg-[#1D4E89] px-6 py-3 text-sm font-medium tracking-wide transition-colors duration-300"
        >
          Free Discovery Call
        </a>

        <button
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-[#0B2B40] p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-slate-200"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-[#1A202C]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#discovery-call"
              onClick={() => setOpen(false)}
              className="bg-[#0B2B40] text-white px-6 py-3 text-sm font-medium tracking-wide text-center mt-2"
            >
              Free Discovery Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
